import React from "react";
import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

const HrjobsGhazi = () => {
  return (
    <>
    <Navbar/>
    <div className="container mx-auto px-4 py-12 text-gray-700">
      {/* ✅ SEO Meta Tags */}
      <Helmet>
        <title>{"HR Jobs in Ghaziabad  | Latest Human Resource Openings 2025"}</title>
        <meta
          name="description"
          content="Apply for the latest HR jobs in Ghaziabad . Explore human resource openings for recruiters, HR executives, managers, and talent acquisition professionals in top Ghaziabad  companies."
        />
        <meta
          name="keywords"
          content="HR jobs in Ghaziabad , human resource jobs in Ghaziabad , HR manager jobs, recruiter jobs in Ghaziabad  NCR, talent acquisition jobs in Ghaziabad "
        />
      </Helmet>

      {/* Page Header */}
      <h1 className="text-3xl font-bold text-gray-800 mb-6">
        HR Jobs in Ghaziabad  – Latest Openings {new Date().getFullYear()}
      </h1>

      {/* Introduction */}
      <p className="mb-6 leading-relaxed">
        Looking for <strong>HR jobs in Ghaziabad </strong>? Ghaziabad  NCR is home to
        hundreds of organizations hiring skilled HR professionals for roles in
        recruitment, employee engagement, payroll, and human resource
        management. Explore the newest <strong>human resource job openings</strong> across startups,
        MNCs, and corporate offices in Ghaziabad .
      </p>

      {/* Top Companies Hiring */}
      <h2 className="text-2xl font-semibold text-gray-800 mb-3">
        Top Companies Hiring HR Professionals in Ghaziabad 
      </h2>
      <ul className="list-disc list-inside mb-6 space-y-1">
        <li>Accenture</li>
        <li>Genpact</li>
        <li>Infosys</li>
        <li>HCL Technologies</li>
        <li>Concentrix</li>
        <li>TCS</li>
        <li>Amazon</li>
      </ul>

      {/* Popular HR Job Roles */}
      <h2 className="text-2xl font-semibold text-gray-800 mb-3">
        Popular HR Job Roles in Ghaziabad 
      </h2>
      <ul className="list-disc list-inside mb-6 space-y-1">
        <li>HR Executive</li>
        <li>HR Manager</li>
        <li>Recruiter / Talent Acquisition Specialist</li>
        <li>Payroll Executive</li>
        <li>HR Business Partner</li>
        <li>Employee Relations Manager</li>
      </ul>

      {/* Fresher Opportunities */}
      <h2 className="text-2xl font-semibold text-gray-800 mb-3">
        HR Jobs for Freshers in Ghaziabad 
      </h2>
      <p className="mb-6">
        Many companies in Ghaziabad  hire fresh graduates for entry-level HR
        positions such as <strong>HR trainees</strong> and <strong>recruitment interns</strong>. These roles
        help candidates gain practical experience in hiring, onboarding, and
        employee management while learning directly from experienced HR
        professionals.
      </p>
    </div>
    <Footer></Footer>
    </>
  );
};

export default HrjobsGhazi;
